import { getHeadersWithToken } from "./api";
import { FormManager } from "./formManager"
import { FlyoutManager } from "./flyoutManager";
import { pushEvent } from "./analytics";
import { showToast } from "./toast";

export function initShipping() {
    const emptyGuid = '00000000-0000-0000-0000-000000000000';

    function getFormIdField(form) {
        return form.querySelector('[name="Id"]');
    }

    document.addEventListener('DOMContentLoaded', function () {
        // Initialize address form handlers on both Shipping Detail page and Shopping Cart page
        const hasShippingDetail = document.querySelector('.shipping-detail');
        const hasShoppingCart = document.querySelector('.tmp-account-cart');
        
        if (hasShippingDetail || hasShoppingCart) {
            // Initialize "Add Address" button click handler
            const addAddressBtn = document.getElementById('addAddress');
            if (addAddressBtn) {
                addAddressBtn.addEventListener('click', function (e) {
                    const addressFormContainer = document.getElementById('addressFormContainer');
                    if (!addressFormContainer) return;
                    addressFormContainer.style.display = 'block';

                    const form = document.getElementById('addressForm');
                    if (form) {
                        form.reset();
                        FormManager.clearFormState(form);
                        
                        // the id field is being set when editing an address, but it was never unset.
                        // so if a user edited an address, then added a new address, the new address
                        // would overwrite the existing address.
                        const idField = getFormIdField(form);
                        if (idField) {
                            idField.value = emptyGuid;
                            console.debug('reset shipping address form id field');
                        } else {
                            console.error('could not find shipping address form id field to reset');
                        }
                    }
                    resetFieldBorders();

                    addressFormContainer.querySelectorAll('h2').forEach(function (el) {
                        el.textContent = "Add Shipping Address";
                    });
                    addressFormContainer.querySelectorAll('.btn-primary').forEach(function (el) {
                        el.textContent = "Add Shipping Address";
                    });

                    // Check if the user has any default address
                    const hasDefaultAddress = document.querySelector('input[name="shippingAddressId"][type="radio"]:checked, .set-default-address:checked');
                    const isDefaultCheckbox = document.getElementById('IsDefault');
                    
                    if (isDefaultCheckbox) {
                        // Check the checkbox by default if no default address exists (but allow user to uncheck)
                        isDefaultCheckbox.checked = !hasDefaultAddress;
                    }

                    e.preventDefault();
                });
            }

            initAddressListHandlers();

            // Clear validation errors when a shipping address is selected (cart page only)
            attachRadioValidationListeners();

            // Clear validation errors when a segment is selected
            const segmentSelect = document.getElementById('segmentIds');
            if (segmentSelect) {
                segmentSelect.addEventListener('change', function () {
                    if (this.selectedOptions.length > 0) {
                        clearValidationError('segment');
                    }
                });
            }

            // dynamically post the shipping address form
            const form = document.getElementById('addressForm');
            const requiredFields = [
                'FirstName',
                'LastName',
                'CompanyName',
                'AddressLine1',
                'State',
                'City',
                'ZipCode'
              ];
              
            if (form) {
                form.addEventListener('submit', async function (e) {
                    e.preventDefault();

                    // Get the id field value
                    const idField = getFormIdField(form);
                    const id = idField ? idField.value : '';

                    // assume we're adding
                    let url = '/api/ShippingAddresses';

                    // if there's not an empty id, we're updating
                    if (id && id !== emptyGuid) {
                        url = `/api/ShippingAddresses/${id}`;
                    }
                    
                    requiredFields.forEach(id => {
                        const input = document.getElementById(id);
                        if (input) {
                          if (!input.value.trim()) {
                            input.classList.add('input-error');
                          } else {
                            input.classList.remove('input-error');
                          }
                        }
                      });

                    await FormManager.postForm(form, url, "Shipping Address", async function (result) {
                        if (result.success) {
                            // GTM: Track successful new address addition (only for new addresses, not updates)
                            pushEvent({
                                'event': 'formSubmission',
                                'formID': 'addNewAddress'
                            });

                            FlyoutManager.close("address");
                            
                            // Check if we're on the shopping cart page
                            const cartAddressList = document.querySelector('.tmp-account-cart__addresses');
                            
                            if (cartAddressList) {
                                // On cart page: fetch and replace the address list dynamically
                                refreshCartAddressList().then(() => {
                                    // Select the newly created address if we have its ID
                                    if (result.data && result.data.id) {
                                        const newAddressRadio = document.querySelector(`input[name="shippingAddressId"][value="${result.data.id}"]`);
                                        if (newAddressRadio) {
                                            newAddressRadio.checked = true;
                                        }
                                    }
                                    // Clear address validation error since address is now selected
                                    clearValidationError('address');
                                });
                            } else {
                                // On shipping detail page: refresh the address list dynamically
                                const addressListContainer = document.getElementById('addressListContainer');
                                if (addressListContainer) {
                                    await refreshAddressList();
                                }
                            }
                        } else {
                            // Handle error
                            console.error(result.error);
                        }
                    });
                });
            }
        }
    });
}

function initAddressListHandlers() {
    document.querySelectorAll('.edit-address').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
            e.preventDefault();
            const flyout = document.getElementById('flyout-address');
            const addressFormContainer = document.getElementById('addressFormContainer');
            if (!addressFormContainer || !flyout) return;
            const form = document.getElementById('addressForm');
            if (form) {
                FormManager.clearFormState(form);
            }
            resetFieldBorders();
            addressFormContainer.style.display = 'block';

            document.getElementById('Id').value = btn.dataset.id || '';
            document.getElementById('DisplayName').value = btn.dataset.displayname || '';
            document.getElementById('FirstName').value = btn.dataset.firstname || '';
            document.getElementById('LastName').value = btn.dataset.lastname || '';
            document.getElementById('CompanyName').value = btn.dataset.companyname || '';
            document.getElementById('AddressLine1').value = btn.dataset.addressline1 || '';
            document.getElementById('AddressLine2').value = btn.dataset.addressline2 || '';
            document.getElementById('City').value = btn.dataset.city || '';
            document.getElementById('State').value = btn.dataset.state || '';
            document.getElementById('ZipCode').value = btn.dataset.zipcode || '';
            document.getElementById('Country').value = btn.dataset.country || '';
            document.getElementById('DeliveryNotes').value = btn.dataset.deliverynotes || ''
            document.getElementById('PhoneNumber').value = btn.dataset.phonenumber || '';
            document.getElementById('IsDefault').checked = btn.dataset.isdefault === 'true';
            document.getElementById('addressFormTitle').textContent = "Edit Shipping Address";
            document.getElementById('addressFormSubmit').textContent = "Update Shipping Address";

            FlyoutManager.open("address");
        });
    });

    document.querySelectorAll('.delete-address').forEach(function (btn) {
        btn.addEventListener('click', async function () {
            // Show confirmation dialog before deleting
            if (!window.confirm('Are you sure you want to delete this address?')) {
                return;
            }

            const addressFormContainer = document.getElementById('addressFormContainer');
            if (!addressFormContainer) return;

            const id = btn.dataset.id;
            const response = await fetch(`/api/ShippingAddresses/${id}`, {
                method: 'DELETE',
                headers: await getHeadersWithToken({
                    'Accept': 'application/json'
                })
            });

            if (response.ok) {
                // Success: you can update the UI or notify the user
                showToast('Address deleted successfully.', 'success');
                // Optionally, remove the address from the DOM or reload the list
            } else if (response.status === 404) {
                showToast('Address not found.', 'error');
            } else {
                showToast('Failed to delete address.', 'error');
            }

            await refreshAddressList();
        });
    });
    document.querySelectorAll('.set-default-address').forEach(function (input) {
        input.addEventListener('change', async function () {
            const id = this.value;
    
            const card = this.closest('.address-card');
            const payload = {
                id: id,
                displayName: card.querySelector('[data-displayname]')?.dataset.displayname || "",
                firstName: card.querySelector('[data-firstname]')?.dataset.firstname || "",
                lastName: card.querySelector('[data-lastname]')?.dataset.lastname || "",
                companyName: card.querySelector('[data-companyname]')?.dataset.companyname || "",
                addressLine1: card.querySelector('[data-addressline1]')?.dataset.addressline1 || "",
                addressLine2: card.querySelector('[data-addressline2]')?.dataset.addressline2 || "",
                city: card.querySelector('[data-city]')?.dataset.city || "",
                state: card.querySelector('[data-state]')?.dataset.state || "",
                zipCode: card.querySelector('[data-zipcode]')?.dataset.zipcode || "",
                country: card.querySelector('[data-country]')?.dataset.country || "",
                deliveryNotes: card.querySelector('[data-deliverynotes]')?.dataset.deliverynotes || "",
                phoneNumber: card.querySelector('[data-phonenumber]')?.dataset.phonenumber || "",
                isDefault: true
            };
    
            const response = await fetch(`/api/ShippingAddresses/${id}`, {
                method: 'PUT',
                headers: await getHeadersWithToken({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }),
                body: JSON.stringify(payload)
            });
    
            if (response.ok) {
                await refreshAddressList();
                window.location.reload();
            } else {
                showToast('Failed to update default address.', 'error');
            }
        });
    });
    
}

async function refreshAddressList() {
    const container = document.getElementById('addressListContainer');
    if (!container) {
        return Promise.resolve();
    }

    const url = container.dataset.addressesUrl || 'getaddresses';

    return await fetch(url)
        .then(response => response.text())
        .then(html => {
            container.innerHTML = html;
            initAddressListHandlers();
        });
}

function refreshCartAddressList() {
    const addressListContainer = document.querySelector('.tmp-account-cart__addresses');
    if (!addressListContainer) {
        return Promise.resolve();
    }

    // Get the refresh URL from data attribute
    const refreshUrl = addressListContainer.dataset.refreshUrl || 'GetAddressList';

    // Fetch the updated address list from the server
    return fetch(refreshUrl)
        .then(response => response.text())
        .then(html => {
            // Replace the content of the address list
            addressListContainer.innerHTML = html;
            
            // Wire up change event listeners to the new radio buttons
            attachRadioValidationListeners();
        })
        .catch(error => {
            console.error('Error refreshing address list:', error);
        });
}

function attachRadioValidationListeners() {
    // Only applies to cart page - attaches listeners to clear validation errors
    const radioButtons = document.querySelectorAll('input[name="shippingAddressId"]');
    radioButtons.forEach(function (radio) {
        radio.addEventListener('change', function () {
            if (this.checked) {
                clearValidationError('address');
            }
        });
    });
}

const cancelBtn = document.querySelector('.address-form__buttons-cancel');
if (cancelBtn) {
    cancelBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const form = document.getElementById('addressForm');
        if (form) {
            form.reset();
            FormManager.clearFormState(form);
        }
        FlyoutManager.close("address");
    });
}

function resetFieldBorders() {
    const requiredFields = [
        'FirstName',
        'LastName',
        'CompanyName',
        'AddressLine1',
        'State',
        'City',
        'ZipCode'
    ];
    requiredFields.forEach(id => {
        const input = document.getElementById(id);
        if (input) {
            input.classList.remove('input-error');
        }
    });
}

function clearValidationError(keyword) {
    const validationSummary = document.querySelector('.validation-summary-errors ul');
    if (validationSummary) {
        const errors = validationSummary.querySelectorAll('li');
        errors.forEach(error => {
            if (error.textContent.toLowerCase().includes(keyword)) {
                error.remove();
            }
        });
        // Hide the summary if no errors remain
        if (validationSummary.querySelectorAll('li').length === 0) {
            const summaryContainer = document.querySelector('.validation-summary-errors');
            if (summaryContainer) {
                summaryContainer.style.display = 'none';
            }
        }
    }
}